import { useSelector } from "react-redux";
import { DictionaryPage } from "../../_components/Abstractions/DictionaryPage";
import { weightDifferencesActions } from "../../_store/weightDifferences.slice";
import { CreateWeightDifference } from "./CreateWeightDifference";
import { WeightDifferencesTable } from "../../_components/Wastes/WeightDifferencesTable";

export function GetWeightDifferences({ activeEventKey, pageEventKey }) {
  const { weightDifferences } = useSelector((x) => x.weightDifferences);
  const { items, paging, sorting } = weightDifferences;
  const table = <WeightDifferencesTable items={items} sorting={sorting} itemActions={weightDifferencesActions} />;
  const createPage = <CreateWeightDifference />;

  return (
    <DictionaryPage
      items={items}
      paging={paging}
      itemsTable={table}
      itemActions={weightDifferencesActions}
      createItem={createPage}
      activeEventKey={activeEventKey}
      pageEventKey={pageEventKey}
      includeSearcher
      sorting={sorting}
    />
  );
}
